import { React, useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import api from "../../Utils/api";
import AgGridComponent from "../../Components/Common/AgGridComponent";
import * as XLSX from "xlsx";
import {
  getCurrentDateTime,
  formatDate
  
} from "../../Utils/commonfunctions";
//import _ from "lodash";
import Spinner from "react-bootstrap/Spinner";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MachineEfficencyReport = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [groupSummeryData, setSummeryData] = useState([]);
  const [groupDetailData, setDetailData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const StartDateRef = useRef(null);

  useEffect(() => {
    if (StartDateRef.current) {
      StartDateRef.current.focus();
    }
  }, []);


  useEffect(() => {
     setStartDate(getCurrentDateTime);
     setEndDate(getCurrentDateTime);
     setSummeryData([]);
     setDetailData([]);
     
   }, []);
  const ClearData = () => {
    setShowTable(false);
    setEndDate(getCurrentDateTime);
    setStartDate(getCurrentDateTime);
    
    
  };
   
  const PrintMachineEfficiencyReport = () => {
    debugger;
    setIsLoading(true); // Show loader

    if (startDate === "" || startDate === null) {
      return Swal.fire("Error", "Please Select Start Date", "error");
    }

    if (endDate === "" || endDate === null) {
      return Swal.fire("Error", "Please Select End Date", "error");
    }
 

    setShowTable(false);
    setSummeryData([]);
     setDetailData([]);
    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);

    api
      .get(
        `Report/PrintMachineEfficiency?START_DATE=${formattedStartDate}&END_DATE=${formattedEndDate}`
      )
      .then((result) => {
        debugger
       const groupSummeryData = result.data.data.summary;
        const groupDetailData = result.data.data.detail;
         setSummeryData(groupSummeryData);
        setDetailData(groupDetailData);
       

        setShowTable(true);
        //calculateSums();
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false); // Hide loader
      });
  };


  const columnDefs = [
  
    {
      headerName: "Efficiency Range %",
      field: "efficiencyRange",
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      
    },
    {
      headerName: "No. Of Machine",
      field: "machineCount",
      width: "120px",
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Seed Weight",
      field: "seedWeight",
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      
    },
    {
      headerName: "Grow",
      field: "growthRate",
      width: "180px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
     
    },
    {
      headerName: "Grow Weight",
      field: "growWeight",
      width: "130px",
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Machine Hours",
      field: "machineHours",
      wrapHeaderText: true,
      width: "150px",
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
    
    },
    {
      headerName: "Max. Hrs",
      field: "maxHours",
      wrapHeaderText: true,
      width: "150px",
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
     
    },
    {
      headerName: "Hrs-Efficiency %",
      field: "efficiency",
      wrapHeaderText: true,
      width: "170px",
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
      
    },
    {
      headerName: "Times",
      field: "times",
      wrapHeaderText: true,
      width: "120px",
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
      
    },
   ];
   const DetailcolumnDefs = [
  
    {
      headerName: "Efficiency Range %",
      field: "efficiencyRange",
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      
    },
    {
      headerName: "No. Of Machine",
      field: "machineCount",
      width: "150px",
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "MachineNo",
      field: "machineNo",
      width: "150px",
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Seed Weight",
      field: "seedWeight",
      width: "200px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
     
    },
    {
      headerName: "Grow",
      field: "growthRate",
      width: "200px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
    
    },
    {
      headerName: "Grow Weight",
      field: "growWeight",
      width: "150px",
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Machine Hours",
      field: "machineHours",
      wrapHeaderText: true,
      width: "150px",
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
     
    },
    {
      headerName: "Max. Hrs",
      field: "maxHours",
      wrapHeaderText: true,
      width: "150px",
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
     
    },
    {
      headerName: "Hrs-Efficiency %",
      field: "efficiency",
      wrapHeaderText: true,
      width: "200px",
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
      
    },
    {
      headerName: "Times",
      field: "times",
      wrapHeaderText: true,
      width: "120px",
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
     
    },
    

  ];


  const exportToExcel = () => {
    if (groupSummeryData.length > 0) {
      const params = {
        fileName: "Machine_Report-Data.xlsx",
        sheetName: "Data",
      };

      const excelData = [];
      const columns = [];

      // Extract column headers
      columnDefs.forEach((column) => {
        columns.push(column.headerName);
      });

      excelData.push(columns);

      // Add data rows
      groupSummeryData.forEach((row) => {
        const rowData = [];
        columnDefs.forEach((column) => {
          rowData.push(row[column.field]);
        });
        excelData.push(rowData);
      });

      const totalRow = [ ];
      excelData.push(totalRow);

      const ws = XLSX.utils.aoa_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, params.sheetName);

      XLSX.writeFile(wb, params.fileName);
    }
  };
 
  const exportToExcelDetail = () => {
    if (groupSummeryData.length > 0) {
      const params = {
        fileName: "DetailMachine_Report-Data.xlsx",
        sheetName: "Data",
      };

      const excelData = [];
      const columns = [];

      // Extract column headers
      columnDefs.forEach((column) => {
        columns.push(column.headerName);
      });

      excelData.push(columns);

      // Add data rows
      groupDetailData.forEach((row) => {
        const rowData = [];
        columnDefs.forEach((column) => {
          rowData.push(row[column.field]);
        });
        excelData.push(rowData);
      });

      // Add total row
       const totalRow = [
      
       ];
      excelData.push(totalRow);

      const ws = XLSX.utils.aoa_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, params.sheetName);

      XLSX.writeFile(wb, params.fileName);
    }
  };
 
   return (
    <>
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <span>Machine EfficiencyReport</span>
        </div>
        <div className="card-body">
          <div className="row col-md-12 mb-3">
            <div className="col-md-2 col-sm-2 col-lg-2">
              <strong htmlFor="startDate">Start Date:</strong>
              <input
                ref={StartDateRef}
                type="datetime-local"
                className="form-control"
                id="startDate"
                placeholder="Enter Machine Start Time"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-2 col-sm-2 col-lg-2">
              <strong htmlFor="endDate">End Date:</strong>
              <input
                type="datetime-local"
                className="form-control"
                id="endDate"
                placeholder="Enter Machine Start Time"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            
            <div className="col-md-2 col-sm-2 col-lg-2">
              <br />
              <button
                type="submit"
                className="btn btn-primary"
                onClick={PrintMachineEfficiencyReport}
              >
                <i class="fa fa-search"></i>
                {"  "}
                Search
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                onClick={ClearData}
                style={{ marginLeft: "10px" }}
              >
                <i class="fa fa-refresh"></i>
                {"  "}
                Clear
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        {isLoading && (
          <>
            <div className="overlay"></div>
            <div className="overlay-content text-center">
              <Spinner animation="" variant="primary">
                <span class="loader"></span>
              </Spinner>
            </div>
          </>
        )}

        <div className="card-header">
          <span>Summery Machine Efficiency</span>
        </div>
        <div className="card-body">
          {showTable ? (
            <div style={{ display: "flex", justifyContent: "end" }}>
              <button className="btn btn-primary mb-2" onClick={exportToExcel}>
                <i class="fa fa-file-excel"></i> Export to Excel
              </button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <strong>Data Not Found</strong>
            </div>
          )}
          {showTable && (
            <>
              <AgGridComponent
                columnDefs={columnDefs}
                rowData={groupSummeryData}
                paginationPageSize={100}
                height="80vh"
              />
            </>
          )}
        </div>
      </div>

        

        <div className="card">
        {isLoading && (
          <>
            <div className="overlay"></div>
            <div className="overlay-content text-center">
              <Spinner animation="" variant="primary">
                <span class="loader"></span>
              </Spinner>
            </div>
          </>
        )}

        <div className="card-header">
          <span>Detail Machine Efficiency</span>
        </div>
        <div className="card-body">
          {showTable ? (
            <div style={{ display: "flex", justifyContent: "end" }}>
              <button className="btn btn-primary mb-2" onClick={exportToExcelDetail}>
                <i class="fa fa-file-excel"></i> Export to Excel
              </button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <strong>Data Not Found</strong>
            </div>
          )}
          {showTable && (
            <>
              <AgGridComponent
                columnDefs={DetailcolumnDefs}
                rowData={groupDetailData}
                paginationPageSize={100}
                height="80vh"
              />
            </>
          )}
        </div>
      </div>

   
    </>
  );
};

export default MachineEfficencyReport;